import { RootState } from 'src/store/store';

export const prepareHeadersHelper = (headers: Headers, state: RootState) => {
  const token = state.users.userToken; // Adjust this based on your Redux state structure

  if (token && token.length > 0) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return headers;
};
